import React, { FC } from 'react';
import classnames from 'classnames';
import { Divider as AntDivider, DividerProps } from 'antd';

import './styles.scss';

export const Divider: FC<DividerProps> = ({ className, ...props }) => (
  <AntDivider className={classnames('tm2-divider', className)} {...props} />
);
